export default {
    weatherUrl: "/weather"
}